module.exports = __webpack_public_path__ + "static/media/garage-regular.4ad9eeae.webm";